import { useState, useEffect } from 'react';

/**
 * Custom hook to detect Small breakpoint (799px and below)
 * Used for responsive design changes specific to the Small breakpoint
 * @returns {boolean} isSmallScreen - true when screen width is <= 799px
 */
const useSmallBreakpoint = () => {
    const [isSmallScreen, setIsSmallScreen] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsSmallScreen(globalThis.innerWidth <= 799);
        };

        checkScreenSize();
        globalThis.addEventListener('resize', checkScreenSize);

        return () => globalThis.removeEventListener('resize', checkScreenSize);
    }, []);

    return isSmallScreen;
};

export default useSmallBreakpoint;